import React from 'react';
import { CardErrorHandling } from '../../sections';
import { Container } from '../../shared';
import './error-handling.scss';
export var ErrorHandling = function (_a) {
    var _b, _c;
    var location = _a.location;
    return (React.createElement("section", null,
        React.createElement(Container, null,
            React.createElement("div", { className: "c-bad-redirects u-mt-6" },
                React.createElement(CardErrorHandling, { url: (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.previousPath) !== null && _c !== void 0 ? _c : '/' })))));
};
